import { useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../../services/api'
import { ArrowLeft, Mail, Loader2, CheckCircle } from 'lucide-react'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try { await api.post('/auth/forgot-password', { email }); setSent(true) } catch (e) {}
    setLoading(false)
  }

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-primary py-12 px-4">
        <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 text-center">
          <div className="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-4"><CheckCircle className="h-8 w-8 text-green-600" /></div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Email Inviata!</h1>
          <p className="text-gray-600 dark:text-gray-400 mb-6">Se esiste un account con <strong>{email}</strong>, riceverai le istruzioni.</p>
          <Link to="/login" className="text-primary-600 font-medium">Torna al login</Link>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-primary py-12 px-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8">
        <div className="text-center mb-6"><span className="text-4xl">🔑</span><h1 className="mt-2 text-xl font-bold text-gray-900 dark:text-white">Recupera Password</h1></div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div><label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Email</label><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input" placeholder="nome@esempio.it" /></div>
          <button type="submit" disabled={loading} className="w-full btn-primary py-3 flex items-center justify-center">{loading ? <><Loader2 className="h-5 w-5 mr-2 animate-spin" />Invio...</> : <><Mail className="h-5 w-5 mr-2" />Invia</>}</button>
        </form>
        <div className="mt-6 text-center"><Link to="/login" className="text-sm text-gray-500 flex items-center justify-center"><ArrowLeft className="h-4 w-4 mr-1" />Torna al login</Link></div>
      </div>
    </div>
  )
}
